import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=1dc0d322&scoped=true&"
import script from "./propaganda.vue?vue&type=script&lang=js&"
export * from "./propaganda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0d322",
  null
  
)

export default component.exports